import Offers from "../components/Offers/Offers";

const OffersPage = () => {
  return <Offers />;
};

export default OffersPage;
